// src/seoConfig.js
export const seoConfig = {
  '/': {
    title: 'A1XPAY | Digital Infrastructure & Automation Platform',
    description: 'A1XPAY is a technology service provider delivering digital infrastructure, automation tools, and seamless integrations. Build reliable, scalable systems faster.',
    keywords: 'digital infrastructure, automation platform, system integration, technology service provider, developer APIs, workflow automation',
  },
  '/about-us': {
    title: 'About A1XPAY | Technology Service Provider',
    description: 'Learn about A1XPAY — a technology platform helping engineering and operations teams ship reliable digital infrastructure with automation and integrations.',
    keywords: 'about A1XPAY, technology company, infrastructure platform, automation company India',
  },
  '/products-services': {
    title: 'Platform & Services | A1XPAY Technology Solutions',
    description: 'Explore A1XPAY platform: integration APIs, workflow automation, developer tooling, and reliability solutions for modern businesses.',
    keywords: 'integration APIs, workflow automation, developer tools, technology platform, system integration',
  },
  '/merchant-solutions': {
    title: 'Business Solutions | A1XPAY Technology Platform',
    description: 'Technology solutions for businesses: connect systems, automate workflows, and scale operations with A1XPAY\'s reliable digital infrastructure.',
    keywords: 'business technology solutions, enterprise automation, digital transformation, system integration India',
  },
  '/privacy-policy': {
    title: 'Privacy Policy | A1XPAY',
    description: 'Read A1XPAY\'s privacy policy — what data we collect, how we use and protect it, and the rights you have over your information.',
    keywords: 'privacy policy, data protection, A1XPAY',
  },
  '/terms-conditions': {
    title: 'Terms & Conditions | A1XPAY',
    description: 'Review the terms governing the use of A1XPAY\'s technology platform, including responsibilities, intellectual property, and limitations of liability.',
    keywords: 'terms and conditions, A1XPAY, user agreement',
  },
  '/return-refund-policy': {
    title: 'Refund & Cancellation Policy | A1XPAY',
    description: 'Understand A1XPAY\'s refund and cancellation policy for technology platform subscriptions and services — clear timelines, eligibility, and process.',
    keywords: 'refund policy, cancellation policy, A1XPAY subscription',
  },
  '/faq': {
    title: 'FAQ | A1XPAY Technology Platform',
    description: 'Answers to common questions about the A1XPAY technology platform, integrations, security, and support.',
    keywords: 'A1XPAY FAQ, technology platform questions, integration support',
  },
  '/contact-us': {
    title: 'Contact Us | A1XPAY',
    description: 'Get in touch with A1XPAY for sales, support, or partnership inquiries. Reach our team in Noida or send us a message online.',
    keywords: 'contact A1XPAY, technology support, sales enquiry, partnership',
  },
};
